/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Issue_Not_PendingInputs */

const en_po_issue_not_pending = /** @type {(inputs: Po_Issue_Not_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`was already answered or withdrawn`)
};

/**
* | output |
* | --- |
* | "was already answered or withdrawn" |
*
* @param {Po_Issue_Not_PendingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_issue_not_pending = /** @type {((inputs?: Po_Issue_Not_PendingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Issue_Not_PendingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_issue_not_pending(inputs)
});